import { useCallback, useEffect, useRef } from "react";

export function useInterval(
  callback: (...args: unknown[]) => void | Promise<void>,
  delay: number
) {
  const callbackRef = useRef(callback);
  const timeoutRef: { current: ReturnType<typeof setInterval> | null } =
    useRef(null);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const set = useCallback(() => {
    timeoutRef.current = setInterval(() => callbackRef.current(), delay);
  }, [delay]);

  const clear = useCallback(() => {
    if (timeoutRef.current) {
      clearInterval(timeoutRef.current);
    }
  }, []);

  useEffect(() => {
    set();
    return clear;
  }, [set, clear]);

  const reset = useCallback(() => {
    clear();
    set();
  }, [clear, set]);

  return { reset, clear };
}
